import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { BulkUploadInstructionComponent } from './bulk-upload-instructions.component';

@NgModule({
  declarations: [BulkUploadInstructionComponent],
  imports: [CommonModule, MatButtonModule, MatDialogModule, MatIconModule],
  exports: [BulkUploadInstructionComponent],
})
export class BulkUploadInstructionsModule {}
